// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import { organizationAuditOperationType, type default as OrganizationAuditOperationType } from './OrganizationAuditOperationType';
import type { ColumnType, Selectable, Insertable, Updateable } from 'kysely';
import { z } from 'zod';

/** Identifier type for public.organization_audit */
export type OrganizationAuditId = string & { __brand: 'OrganizationAuditId' };

/** Represents the table public.organization_audit */
export default interface OrganizationAuditTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<OrganizationAuditId, OrganizationAuditId | undefined, OrganizationAuditId>;

  /** Database type: pg_catalog.text */
  organizationId: ColumnType<string, string, string>;

  /** Database type: pg_catalog.jsonb */
  oldData: ColumnType<unknown | null, unknown | null, unknown | null>;

  /** Database type: pg_catalog.jsonb */
  newData: ColumnType<unknown | null, unknown | null, unknown | null>;

  /** Database type: pg_catalog.text */
  updatedBy: ColumnType<string, string, string>;

  /** Database type: pg_catalog.timestamptz */
  updatedAt: ColumnType<Date, Date | string | undefined, Date | string>;

  /** Database type: public.organization_audit_operation_type */
  operationType: ColumnType<OrganizationAuditOperationType, OrganizationAuditOperationType, OrganizationAuditOperationType>;
}

export const organizationAuditId = z.string();

export const organizationAudit = z.object({
  id: organizationAuditId,
  organization_id: z.string(),
  old_data: z.unknown().nullable(),
  new_data: z.unknown().nullable(),
  updated_by: z.string(),
  updated_at: z.date(),
  operation_type: organizationAuditOperationType,
});

export const organizationAuditInitializer = z.object({
  id: organizationAuditId.optional(),
  organization_id: z.string(),
  old_data: z.unknown().optional().nullable(),
  new_data: z.unknown().optional().nullable(),
  updated_by: z.string(),
  updated_at: z.date().optional(),
  operation_type: organizationAuditOperationType,
});

export const organizationAuditMutator = z.object({
  id: organizationAuditId.optional(),
  organization_id: z.string().optional(),
  old_data: z.unknown().optional().nullable(),
  new_data: z.unknown().optional().nullable(),
  updated_by: z.string().optional(),
  updated_at: z.date().optional(),
  operation_type: organizationAuditOperationType.optional(),
});

export type OrganizationAudit = Selectable<OrganizationAuditTable>;

export type NewOrganizationAudit = Insertable<OrganizationAuditTable>;

export type OrganizationAuditUpdate = Updateable<OrganizationAuditTable>;
